import {defineMessages} from 'react-intl';

export default defineMessages({
	contentBenefits: {
		id: 'auth.signup.benefits',
		defaultMessage:
			'<benefits>' +
			'<item>Add your favorite items to your wishlist</item>' +
			'<item>Save your contact informations for a faster checkout</item>' +
			'<item>Check your order status</item>' +
			'<requiresText>Access exclusive collections</requiresText>' +
			'</benefits>',
	},
	contentSubmit: {
		id: 'auth.signup.submit',
		defaultMessage: 'Create Account',
	},
	contentTitle: {
		id: 'auth.signup.title',
		defaultMessage: 'Create account',
	},
});
